import { COMMUNITY_WRITE_TYPES } from '../../../data/define';
import IcX from '../../../assets/image/ic_x.svg';
import IcArrow from '../../../assets/image/ic_chevron_right.svg';

interface TopHeaderBarProps {
  type: number;
  setWriteModalOpen: (open: boolean) => void;
  registorDisabled: boolean;
  onSubmit?: () => void;
  onClose?: () => void;
}

export default function TopHeaderBar({ 
  type, 
  setWriteModalOpen, 
  registorDisabled, 
  onSubmit = () => {}, 
  onClose 
}: TopHeaderBarProps) {
  return (
    <div className="h-[48px] flex justify-center items-center w-full bg-white px-[20px] flex-grow-0 flex-shrink-0">
      <button
        type="button"
        className="w-[24px] h-[24px] cursor-pointer"
        onClick={onClose || (() => {})}
      >
        <img src={IcX} alt="back" />
      </button>
      <button
        type="button"
        className="flex justify-center items-center flex-grow flex-shrink-1"
        onClick={() => setWriteModalOpen(true)}
      >
        <div className="text-[18px] leading-[19px] font-[700] text-[#2D2D2D] text-center shrink-0">
          {COMMUNITY_WRITE_TYPES.find((item) => item.id === type)?.title}
        </div>
        <div>
          <img src={IcArrow} alt="arrow" className="rotate-90" />
        </div>
      </button>
      <button
        type="button"
        className="h-[24px] text-[16px] font-[600]"
        style={{ color: registorDisabled ? '#BDBDBD' : '#5EBEBB' }}
        disabled={registorDisabled}
        onClick={onSubmit}
      >
        등록
      </button>
    </div>
  );
}

